<template>
    <b-container fluid>
        <app-vecindapp-banner />
        <b-row>
            <b-col>
                <app-title>Seleccione el cliente con el cual va a trabajar</app-title>
            </b-col>
        </b-row>
        <b-row>
            <div v-if="!!currentUser.clients.length" class="w-100">
                <b-col v-for="(client, idx) in currentUser.clients" :key="idx" class="my-3" cols="12">
                    <b-btn block variant="primary" @click="selectClient(client)">{{ client.name }}</b-btn>
                </b-col>
            </div>
            <b-col v-else>
                <b-alert variant="warning" show>No tiene ningún cliente asociado</b-alert>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapMutations } from 'vuex'
import * as mutations from '@store/_mutations'
export default {
    data: () => ({}),
    computed: {},
    methods: {
        ...mapMutations({
            setCurrentClient: mutations.SET_CURRENT_CLIENT,
        }),
        async selectClient(client) {
            this.setCurrentClient(client)
            // Send client ID to backend to store in session
            await this.$repo.post('session/client', {
                client_id: client.id
            })
            this.next()
        },
        
        next() {
            if (this.$route.name === this.currentProfile.stop_login) {
                return this.$router.push({
                    name: this.currentProfile.default_screen,
                })
            }
            return this.$router.push({ name: 'selectVenuePage' })
        },
    },
    mounted() {
        if (this.currentUser.clients.length === 1) {
            const client = this.currentUser.clients[0]
            this.setCurrentClient(client)
            this.next()
        }
    },
}
</script>
